// 配列同士重複した値があるかチェック、あればtrue
export const isDuplicateValue = (arr1, arr2) => [...arr1, ...arr2].filter(item => arr1.includes(item) && arr2.includes(item)).length > 0
